import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "flex justify-center items-center min-h-screen"
}
const _hoisted_2 = {
  key: 1,
  class: "flex flex-col items-center justify-center min-h-screen px-6 text-center"
}
const _hoisted_3 = { class: "text-2xl font-bold text-white mb-2" }
const _hoisted_4 = { class: "text-white/70 mb-6" }
const _hoisted_5 = {
  key: 2,
  class: "pb-32"
}
const _hoisted_6 = { class: "header-section" }
const _hoisted_7 = { class: "flex items-center px-6 pt-16 pb-6" }
const _hoisted_8 = { class: "header-title" }
const _hoisted_9 = { class: "hero-image-container" }
const _hoisted_10 = ["src", "alt"]
const _hoisted_11 = ["alt"]
const _hoisted_12 = { class: "content-section" }
const _hoisted_13 = { class: "title-price-row" }
const _hoisted_14 = { class: "activity-title" }
const _hoisted_15 = {
  key: 0,
  class: "activity-price"
}
const _hoisted_16 = { class: "about-section" }
const _hoisted_17 = { class: "section-title" }
const _hoisted_18 = ["innerHTML"]
const _hoisted_19 = { class: "bottom-bar" }
const _hoisted_20 = { class: "bottom-bar-content" }
const _hoisted_21 = { key: 1 }

import { ref, computed } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { IonContent, IonButton, IonIcon, IonSpinner } from '@ionic/vue';
import { Swiper, SwiperSlide } from 'swiper/vue';
import { Pagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination';
import { chevronBack, alertCircle } from 'ionicons/icons';
import { useI18n } from 'vue-i18n';

import useQueue from '@/modules/queue/composables/useQueue';
import useToast from '@/shared/composables/useToast';
import { anykrowdApi } from '@/api/anykrowdApi';

// Minimal setup

export default /*@__PURE__*/_defineComponent({
  __name: 'QueueActivityDetailPage',
  setup(__props) {

const route = useRoute();
const router = useRouter();
const { t } = useI18n();
const { presentToast } = useToast();

const activityId = ref(parseInt(route.params.activityId as string));

// Navigation helpers
const navigateToQueues = () => {
	router.replace({ name: 'queue-activities' });
};

// Queue composables
const {
	getQueueActivity,
	formatPrice,
} = useQueue();

// Load activity data
const { activity, isFetchedActivity } = getQueueActivity(activityId.value);

// Loading state
const isLoading = computed(() => !isFetchedActivity.value);
const isCheckingAvailability = ref(false);

// Swiper modules
const swiperModules = [Pagination];

// Computed property for all images (main image + gallery)
const allImages = computed(() => {
	if (!activity.value) return [];
	const images = [];

	// Add main image first
	if (activity.value.image_url) {
		images.push(activity.value.image_url);
	}

	// TODO: Uncomment to enable gallery images
	// Add gallery images
	// if (activity.value.gallery_images && activity.value.gallery_images.length > 0) {
	// 	images.push(...activity.value.gallery_images);
	// }

	return images;
});

// Check if activity is available for booking
const checkAvailabilityAndNavigate = async () => {
	if (!activity.value) {
		await presentToast('top', t('queue.no_activities_available'), 3000, 'danger');
		return;
	}

	isCheckingAvailability.value = true;

	try {
		// Check the activity's availability
		const { data } = await anykrowdApi.get(
			`/queue/activities/${activity.value.id}/can-book?queue_type=normal`,
			true
		);

		if (!data.can_book) {
			await presentToast('top', data.reason || t('queue.not_available_for_booking'), 5000, 'danger');
			return;
		}

		// Check queue type and navigate accordingly
		if (activity.value.queue_type === 'chronological') {
			// For chronological queues, skip date selection and go directly to ticket purchase
			router.push({
				name: 'queue-tickets-buy',
				params: {
					activityId: activity.value.id
				}
			});
		} else {
			// For time slot queues, navigate to date selection page
			router.push({
				name: 'queue-date-selection',
				params: {
					activityId: activity.value.id
				}
			});
		}
	} catch (error: any) {
		console.error('Error checking availability:', error);
		await presentToast('top', t('queue.error_checking_availability'), 3000, 'danger');
	} finally {
		isCheckingAvailability.value = false;
	}
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonContent), { class: "queue-activity-detail" }, {
    default: _withCtx(() => [
      (isLoading.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createVNode(_unref(IonSpinner), {
              name: "dots",
              class: "text-white text-4xl"
            })
          ]))
        : (!_unref(activity))
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createVNode(_unref(IonIcon), {
                icon: _unref(alertCircle),
                class: "text-6xl text-white/60 mb-4"
              }, null, 8, ["icon"]),
              _createElementVNode("h2", _hoisted_3, _toDisplayString(_unref(t)('queue.activity_not_found')), 1),
              _createElementVNode("p", _hoisted_4, _toDisplayString(_unref(t)('queue.activity_not_found_description')), 1),
              _createVNode(_unref(IonButton), {
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(router).back())),
                fill: "outline",
                color: "light"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)('general.go_back')), 1)
                ]),
                _: 1
              })
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createVNode(_unref(IonButton), {
                    fill: "clear",
                    color: "light",
                    onClick: navigateToQueues,
                    class: "back-button"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(IonIcon), {
                        icon: _unref(chevronBack),
                        class: "back-icon"
                      }, null, 8, ["icon"])
                    ]),
                    _: 1
                  }),
                  _createElementVNode("h1", _hoisted_8, _toDisplayString(_unref(t)('queue.activity_details')), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_9, [
                (allImages.value.length > 0)
                  ? (_openBlock(), _createBlock(_unref(Swiper), {
                      key: 0,
                      modules: swiperModules,
                      pagination: { clickable: true },
                      "slides-per-view": 1,
                      class: "image-swiper"
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(allImages.value, (image, index) => {
                          return (_openBlock(), _createBlock(_unref(SwiperSlide), { key: index }, {
                            default: _withCtx(() => [
                              _createElementVNode("img", {
                                src: image,
                                alt: `${_unref(activity).name} - Image ${index + 1}`,
                                class: "w-full h-full object-cover rounded-2xl hero-image"
                              }, null, 8, _hoisted_10)
                            ]),
                            _: 2
                          }, 1024))
                        }), 128))
                      ]),
                      _: 1
                    }))
                  : (_openBlock(), _createElementBlock("img", {
                      key: 1,
                      src: "/api/placeholder/400/320",
                      alt: _unref(activity).name,
                      class: "w-full h-full object-cover rounded-2xl hero-image"
                    }, null, 8, _hoisted_11))
              ]),
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("h2", _hoisted_14, _toDisplayString(_unref(activity).name), 1),
                  (_unref(activity).regular_price || _unref(activity).priority_price)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_15, _toDisplayString(_unref(formatPrice)(_unref(activity).regular_price || _unref(activity).priority_price, _unref(activity).regularCurrency || _unref(activity).priorityCurrency)), 1))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_16, [
                  _createElementVNode("h3", _hoisted_17, _toDisplayString(_unref(t)('queue.about_this_activity')), 1),
                  (_unref(activity).description)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        class: "description-text",
                        innerHTML: _unref(activity).description
                      }, null, 8, _hoisted_18))
                    : _createCommentVNode("", true)
                ])
              ]),
              _createElementVNode("div", _hoisted_19, [
                _cache[1] || (_cache[1] = _createElementVNode("div", { class: "bottom-bar-backdrop" }, null, -1)),
                _createElementVNode("div", _hoisted_20, [
                  _createVNode(_unref(IonButton), {
                    expand: "block",
                    fill: "solid",
                    class: "book-now-button",
                    onClick: checkAvailabilityAndNavigate,
                    disabled: _unref(activity).status !== 'published' || isCheckingAvailability.value
                  }, {
                    default: _withCtx(() => [
                      (isCheckingAvailability.value)
                        ? (_openBlock(), _createBlock(_unref(IonSpinner), {
                            key: 0,
                            name: "dots"
                          }))
                        : (_openBlock(), _createElementBlock("span", _hoisted_21, _toDisplayString(_unref(t)('queue.book_now')), 1))
                    ]),
                    _: 1
                  }, 8, ["disabled"])
                ])
              ])
            ]))
    ]),
    _: 1
  }))
}
}

})